module.exports = __webpack_public_path__ + "img/exercise_image_active.d158d7e5.svg";